import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import { useStore } from 'core/store';
import { Card } from 'core/components/card';
import { TextField } from 'core/components/text-field';
import { LabelTooltip } from 'core/components/label-tooltip';
import Checkbox from 'core/components/checkbox';
import styles from './search-form.styles';

const EXPANDED_CUSTOMERS_AND_OFFERS_SEARCH_TOOLTIP_TEXT = `This will search within additional 
criteria not shown on the columns below.

Expanded search includes: email, primary phone, and additional phone numbers`;

const EXPANDED_POLICIES_SEARCH_TOOLTIP_TEXT = `Affinity, Car VINs, Mortgage lender name, and drivers/people on policy for the following attributes: first name, last name, and DOB (formatted as YYYY-MM-DD).`;

const SearchForm = ({ classes, value, onChange, onSearchButtonPress, location }) => {
  const searchingOffersIndex = location.pathname === '/search/offers';
  const searchingCustomersIndex = location.pathname === '/search/customers';
  const searchingPoliciesIndex = location.pathname === '/search/policies';
  const { search: store } = useStore();

  const toggleExpandedSearch = useCallback(
    (_, expanded) => {
      store.setExpandedSearch(expanded);
      onSearchButtonPress();
    },
    [store, onSearchButtonPress]
  );

  return (
    <Card className={classes.card} type="secondary">
      <CardContent className={classes.content}>
        <div className={classes.search}>
          <TextField
            label="Search"
            name="query"
            className={classes.textField}
            autoComplete="off"
            onChange={onChange}
            value={value}
          />
          <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            data-cy="submit-search"
            onClick={onSearchButtonPress}
          >
            Search
          </Button>
        </div>
        {searchingOffersIndex && (
          <Checkbox
            id="toggleExpandedSearch"
            label="Expanded Search"
            tooltipText={EXPANDED_CUSTOMERS_AND_OFFERS_SEARCH_TOOLTIP_TEXT}
            tooltipLabel="More Info"
            onChange={toggleExpandedSearch}
            value={store.expandedSearch}
          />
        )}
        {searchingCustomersIndex && (
          <Checkbox
            id="toggleExpandedSearch"
            label="Expanded Search"
            tooltipText={EXPANDED_CUSTOMERS_AND_OFFERS_SEARCH_TOOLTIP_TEXT}
            tooltipLabel="More Info"
            onChange={toggleExpandedSearch}
            value={store.expandedSearch}
          />
        )}
        {searchingPoliciesIndex && (
          <LabelTooltip
            tooltip={{
              onHoverText: EXPANDED_POLICIES_SEARCH_TOOLTIP_TEXT,
              label: 'What can I search?'
            }}
            placement="bottom"
          />
        )}
      </CardContent>
    </Card>
  );
};

SearchForm.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSearchButtonPress: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired
};

export default withStyles(styles)(SearchForm);
